import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';
import ShimmerEmptyImageTextComponent from './shimmerEmptyImageTextComponent';
import EmptyLeads from '../../../../../assets/svgComponents/EmptyLeads';

import './leadsShimmerComponent.css';

const LeadsShimmerComponent = ({showShimmer = true}) => {
  return (
    <>
      {showShimmer ? (
        <>
          {Array.from({length: 10}).map((val, idx) => (
            <div key={idx} className="et-v2-leads-shimmer-wrap">
              <ShimmerComponent />
            </div>
          ))}
        </>
      ) : (
        <div className="et-v2-leads-empty-shimmer-wrap">
          <ShimmerEmptyImageTextComponent
            ImageComponent={EmptyLeads}
            titleTxt="No new form submissions"
            subTitleTxt="You currently have no form submissions"
          />
        </div>
      )}
    </>
  );
};

export default LeadsShimmerComponent;
